import { SentimentName, SentimentType } from 'v2/core/entities/fields';

export const isValidSentiment = (
  sentiment: SentimentName | SentimentType | string,
): boolean => {
  switch (sentiment) {
    case SentimentName.POSITIVE:
    case SentimentType.Positive:
    case SentimentName.NEUTRAL:
    case SentimentType.Neutral:
    case SentimentName.NEGATIVE:
    case SentimentType.Negative:
      return true;
    default:
      return false;
  }
};
